import { VER_CATTLE } from './constant';
import { wasm, allocateMemByWasm, convertToString, convertFromString, allocate32MemByWasm } from './utils/dbk_sign';
import { sortParams } from './utils/encode';
import { getSecond } from './utils/random';
function checkWasm() {
    if (!wasm) {
        throw new Error('module not inited');
    }
}
export function getSignType() {
    // `get_sign_type(uint32_t* out)` in cpp, so we use Int32Array
    const uint32Ptr = allocate32MemByWasm(1);
    wasm.get_sign_type(uint32Ptr.byteOffset);
    return uint32Ptr[0];
}
/**
 * @alias makeNonceWasm
 */
export function mkNW(len = 40) {
    checkWasm();
    const retVal = allocateMemByWasm(len);
    wasm.r_s(len, retVal.byteOffset);
    const str = convertToString(retVal.byteOffset, len);
    const stype = getSignType();
    return stype === 100121 /* DEBANK_WEB */ ? `nc_${str}` : `n_${str}`;
}
/**
 * @alias makeSignFull
 */
export function makeSF(m, u, params, n, t) {
    checkWasm();
    const retArr = allocateMemByWasm(64);
    const bufs = [
        convertFromString(m.toUpperCase()),
        convertFromString(u),
        convertFromString(sortParams(params)),
        convertFromString(n),
        convertFromString(t + ''),
    ];
    const sz = wasm.mk_s_f(bufs[0].byteOffset, bufs[1].byteOffset, bufs[2].byteOffset, bufs[3].byteOffset, bufs[4].byteOffset, retArr.byteOffset);
    bufs.forEach(buf => wasm.free(buf.byteOffset));
    return convertToString(retArr.byteOffset, sz);
}
/* makeSignatureWasm */
export function makeGsW(params, method, uripath, opts = {}) {
    checkWasm();
    const nonce = opts.nonce || mkNW();
    const ts = parseInt(opts.timestamp, 10) || getSecond();
    const ver = opts.version || VER_CATTLE;
    const signature = makeSF(method, uripath, params, nonce, ts);
    return {
        signature,
        nonce,
        ts,
        version: ver
    };
}
